export interface LocaleFormat {
  decimalSeparator: string;
  thousandsSeparator: string;
}

export function getLocaleFormat(
  currencyCode: string,
  locale: string,
): LocaleFormat {
  try {
    const formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
    });

    const parts = formatter.formatToParts(1234.56);

    let decimalSeparator = ".";
    let thousandsSeparator = ",";

    const decimalPart = parts.find((p) => p.type === "decimal");
    const groupPart = parts.find((p) => p.type === "group");

    if (decimalPart) {
      decimalSeparator = decimalPart.value;
    }
    if (groupPart) {
      thousandsSeparator = groupPart.value;
    }

    return {
      decimalSeparator,
      thousandsSeparator,
    };
  } catch {
    return {
      decimalSeparator: ".",
      thousandsSeparator: ",",
    };
  }
}
